import Vue from 'vue';
import Component from 'vue-class-component'
import StatementComponent from './StatementComponent'
import StatementCard from './StatementView.vue'
import SaveButton from '@/components/buttons/SaveButton.vue'
import ClearButton from '@/components/buttons/ClearButton.vue'
import { focus } from 'vue-focus';
import statementStore from '@/store/statement/statement-store';
import feedStore from '@/store/feed/feed-store';
import LoadingIndicator from '@/components/LoadingIndicator'
import authStore from '@/store/auth/auth-store';
import LoginButton from '@/components/buttons/LoginButton';
import RichText from '@/components/shared/RichText';
import StatementView from './StatementView';

@Component({
  directives: { focus: focus },
  name: 'statements',
  components: {
    StatementView,
    LoginButton,
    LoadingIndicator,
    StatementCard,
    SaveButton,
    ClearButton,
    RichText
  },
  metaInfo () {
    return {
      title: statementStore.state.statements && statementStore.state.statements.length == 1 ? ('Jybe Statement :' + statementStore.state.statements[0].text) : 'Jybe Statements',
      meta: [
        { vmid: 'description', name: 'description', 
          content: statementStore.state.statements && statementStore.state.statements.length == 1 ? ('Jybe Statement :' + statementStore.state.statements[0].text) : 'Jybe Statements' 
        }
      ]
    }
  }
})
export default class Statements extends StatementComponent {
  protected inputFocused = true;

  mounted (): void {
    console.log('Statements.ts: mounted')

    this.$store.subscribe((mutation, state) => {
      console.log('Statements mutation: type = %j', mutation.type)

      if (mutation.type === 'feed/setType') {
        console.log('Statements mutation: payload = %j', mutation.payload)
        if(mutation.payload.type === 'statement-edit') {
          this.inputFocused = true;
          // focus on statement input 
/*           
          console.log('Statements mutation: focus refs = %j', this.$refs)
          console.log('Statements mutation: focus el = %j', this.$el)
          const stmtField = <HTMLInputElement>(this.$refs.stmt as Vue).$el
          console.log('Statements mutation: statement field = %j', stmtField)
          stmtField.focus();
 */
        }
      }

      if (mutation.type === 'feed/setFeed') {
        this.fetchStatements()
      }

      if (mutation.type === 'feed/setUserId') {
        this.fetchStatements()
      }
    })

    if (feedStore.isInitialized) {
      this.fetchStatements()
    }
  }

  get isAuthenticated():boolean {return authStore.isAuthenticated}

  get isLoading():boolean {return statementStore.isLoading}

  get buttonType():string {return authStore.isAuthenticated ? 'react' : 'nonauth'}

  protected fetchStatements() {
    statementStore.dispatchInitFetchStatements()
  }

  protected focus() : void {
    this.inputFocused = true;
  }

  protected blur() : void {
    this.inputFocused = false;
  }

  protected resetForm() : void {
    statementStore.dispatchResetStatementForm()
  }
}
